module.exports = __webpack_public_path__ + "img/lc.c056c2a7.svg";